import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "saveNewCard" };
const _hoisted_2 = { class: "stripeForm" };
const _hoisted_3 = { class: "form-group intestatario" };
const _hoisted_4 = { class: "form-group" };
const _hoisted_5 = {
    id: "card-number",
    class: "field empty",
    ref: "cardNumberRef"
};
const _hoisted_6 = { class: "row" };
const _hoisted_7 = { class: "col-8" };
const _hoisted_8 = { class: "form-group" };
const _hoisted_9 = {
    id: "card-expiry",
    class: "field empty",
    ref: "card-expiry-ref"
};
const _hoisted_10 = { class: "col-4" };
const _hoisted_11 = { class: "form-group" };
const _hoisted_12 = {
    id: "card-cvc",
    class: "field empty third-width",
    ref: "card-cvc-ref"
};
const _hoisted_13 = { class: "d-flex justify-content-center mt-3" };
const _hoisted_14 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _cache[2] || (_cache[2] = _createElementVNode("label", null, "Intestatario", -1)),
                _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-conrol",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.cardholderName) = $event))
                }, null, 512), [
                    [_vModelText, _ctx.cardholderName]
                ])
            ]),
            _createElementVNode("div", _hoisted_4, [
                _cache[3] || (_cache[3] = _createElementVNode("label", null, "Numero", -1)),
                _createElementVNode("div", _hoisted_5, null, 512)
            ]),
            _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _cache[4] || (_cache[4] = _createElementVNode("label", null, "Scadenza", -1)),
                        _createElementVNode("div", _hoisted_9, null, 512)
                    ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "label" }, "CVC", -1)),
                        _createElementVNode("div", _hoisted_12, null, 512)
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
                class: "genericButton btn-linear-blue mt-1",
                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.addCard())),
                disabled: _ctx.addButtonDisabled
            }, " Aggiungi carta ", 8, _hoisted_14)
        ])
    ]));
}
